import { testimonials } from '@/mocks/manhwa';

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-5">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-sm text-primary-600 font-medium">读者反馈</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            读者们这样说
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            来自数百万韩漫爱好者的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-5">
          {testimonials.map((t, i) => (
            <div
              key={t.id}
              className={`bg-background-50 p-6 md:p-5 rounded-lg ${
                i === testimonials.length - 1 ? 'opacity-60' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <i key={idx} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-2">{t.title}</h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-4">
                {t.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}